import { createHttpLink } from '@apollo/client';
import { isServerSide } from '../../../../utils/validators/isServerSide';
import { isZillowURL } from '../../../../utils/validators/isZillowURL';

const createAPILink = () =>
    createHttpLink({
        uri:
            !isServerSide() && isZillowURL(window.location.origin)
                ? '/homeloans/mortgage/api/graphql'
                : '/api/mortgage/graphql',
    });

export { createAPILink };
